/* WAVE Hair Extensions - lift the WhatsApp button clear of the Klaviyo teaser
   Built 30 September 2026.

   WHAT THIS FIXES
   On phones the Klaviyo "Get 10% off now" teaser renders as a full width bar
   50px tall pinned to the very bottom of the screen (measured 375 x 812 on a
   product page: top edge 762, bottom edge 812). The WhatsApp button sits 20px
   up from the bottom in the right hand corner, so the bar covered the lower
   half of the green circle. Daniel reported it on 30 September.

   Note that on collection pages the same teaser renders as an 84px circle in
   the BOTTOM LEFT corner, which does not touch the WhatsApp button at all,
   and on desktop it is a 284px rectangle in the bottom left, which also does
   not touch it. So a blanket "always sit higher on mobile" rule would push
   the button up the page for no reason most of the time, which is the exact
   problem the 19 September note in wave-whatsapp.js was written to solve.

   WHAT IT DOES INSTEAD
   It measures the teaser's real rectangle and only lifts the button when that
   rectangle genuinely sits across the bottom of the screen AND overlaps the
   button horizontally. Otherwise the lift is zero and the button stays low in
   the corner where a chat button belongs.

   WHY IT IS A SEPARATE FILE
   Klaviyo's class names are hashed (kl-teaser-XNuzcR on mobile,
   kl-teaser-UdDuJb on desktop) and Klaviyo regenerates them, so the match is
   deliberately on the "kl-teaser" prefix only. Keeping this apart from
   wave-whatsapp.js means a Klaviyo change is a one file fix and the WhatsApp
   widget itself never has to be touched.

   WHY body #wave-wa AND NOT JUST #wave-wa
   wave-whatsapp.js injects its styles into a <style> tag at DOMContentLoaded,
   which lands after this file in the document. Equal specificity would lose,
   so the selectors here are prefixed with body to win on specificity rather
   than on order. Do not remove that prefix.
*/
(function () {
  if (window.__waveWaTeaserLift) return;
  window.__waveWaTeaserLift = true;

  var GAP = 12; /* breathing room between the teaser and the green circle */

  var css = ''
    + 'body #wave-wa{bottom:calc(20px + var(--wave-wa-teaser,0px) + env(safe-area-inset-bottom,0px))}'
    + '@media (max-width:1024px){'
    +   'body #wave-wa{bottom:calc(20px + var(--wave-wa-teaser,0px) + env(safe-area-inset-bottom,0px))}'
    +   'body #wave-wa.has-bar{bottom:calc(74px + var(--wave-wa-teaser,0px) + env(safe-area-inset-bottom,0px))}'
    + '}';

  function addStyle() {
    if (document.getElementById('wave-wa-teaser-css')) return;
    var s = document.createElement('style');
    s.id = 'wave-wa-teaser-css';
    s.textContent = css;
    document.head.appendChild(s);
  }

  var queued = false;

  function measure() {
    queued = false;

    var wrap = document.getElementById('wave-wa');
    if (!wrap) return;

    var lift = 0;
    var teasers = document.querySelectorAll('[class*="kl-teaser"]');

    for (var i = 0; i < teasers.length; i++) {
      var tr = teasers[i].getBoundingClientRect();
      if (tr.width < 10 || tr.height < 10) continue;

      /* across the bottom of the window, not somewhere up the page */
      var atBottom = tr.bottom > (window.innerHeight - 120) && tr.top < window.innerHeight;
      if (!atBottom) continue;

      /* only matters if it is under the button, not off to one side.
         The button's left and right edges do not move when it lifts, so
         reading them here cannot set up a loop. */
      var wr = wrap.getBoundingClientRect();
      if (tr.right <= wr.left || tr.left >= wr.right) continue;

      var thisLift = Math.round(window.innerHeight - tr.top) + GAP;
      if (thisLift > lift) lift = thisLift;
    }

    wrap.style.setProperty('--wave-wa-teaser', lift + 'px');
  }

  function queue() {
    if (queued) return;
    queued = true;
    if (window.requestAnimationFrame) window.requestAnimationFrame(measure);
    else measure();
  }

  function start() {
    addStyle();
    measure();
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });

    /* Klaviyo loads itself well after the page, and the WhatsApp button only
       appears after a four second delay, so poll for the first twenty
       seconds and then leave it to scroll and resize. */
    var tries = 0;
    var early = setInterval(function () {
      measure();
      if (++tries > 40) clearInterval(early);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
